import { LocaleStatus, } from '@wix/ambassador-multilingual-v1-locale/types';
export const getMultilingualQueryParam = (multilingual) => {
    const locale = getLocaleFromMultilingual(multilingual);
    return locale ? `?lang=${locale.languageCode}` : '';
};
const getLocaleFromMultilingual = (multilingual) => {
    if (!multilingual) {
        return undefined;
    }
    if ('currentLanguage' in multilingual) {
        if (multilingual.currentLanguage) {
            const locale = multilingual.siteLanguages.find((lang) => lang.languageCode === multilingual.currentLanguage);
            if (!locale?.isPrimaryLanguage &&
                // @ts-expect-error
                locale?.resolutionMethod === 'QueryParam') {
                return locale;
            }
        }
    }
    else {
        return multilingual.siteLanguages.find((s) => s.status === LocaleStatus.DEFAULT);
    }
    return undefined;
};
//# sourceMappingURL=get-multilingual-query-param.js.map